import { render } from "./VirtualNumbersTable.vue?vue&type=template&id=1e50912e"
import script from "./VirtualNumbersTable.vue?vue&type=script&lang=js"
export * from "./VirtualNumbersTable.vue?vue&type=script&lang=js"

import "./VirtualNumbersTable.vue?vue&type=style&index=0&id=1e50912e&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__